/**
 * The spacing between the items in a task list.
 */
export const TASK_LIST_ITEM_GAP = 6;
